﻿{
  "version": 1,
  "gameId": "spades",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0 },
  "cosmetics": { "sharedCardCatalog": true },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "spades.rules.navigationLabel",
    "kickerKey": "spades.rules.kicker",
    "titleKey": "spades.rules.title",
    "summaryKey": "spades.rules.summary",
    "sections": [
      { "id": "teams", "key": "spades.rules.teams" },
      { "id": "bid", "key": "spades.rules.bid" },
      { "id": "follow", "key": "spades.rules.follow" },
      { "id": "nil", "key": "spades.rules.nil" },
      { "id": "scoring", "key": "spades.rules.scoring" },
      { "id": "bags", "key": "spades.rules.bags" },
      { "id": "finish", "key": "spades.rules.finish" }
    ],
    "settingsAccess": false
  }
}
